import React from 'react';

const Dots = ({ currentPage, onClickDotEvent }) => {
  const Dot = ({ num }) => {
    return (
      <>
      <div
        className={currentPage === num ? 'dot_border black' : 'dot_border'}
        onClick={() => onClickDotEvent(num)} 
      >
        <div
        className={currentPage === num ? 'dot_style black' : 'dot_style'}
        onClick={() => onClickDotEvent(num)}
      />
      </div>
      </>
      
    );
  };

  return (
    <div className='slide_navigation'>
      <div className='dot_nav' 
        >
        {[...Array(6)].map((_, index) => (
          <Dot key={index} num={index + 1} />
        ))}
      </div>
    </div>
  );
};

export default Dots;
// import React from 'react';

// const Dots = ({ currentPage, pageCount = 6, onClickDotEvent }) => {
//   return (
//     <div className="slide_navigation" aria-label="페이지 이동">
//       <div className="dot_nav">
//         {Array.from({ length: pageCount }).map((_, index) => {
//           const pageNumber = index + 1;
//           const isActive = currentPage === pageNumber;

//           return (
//             <button
//               key={pageNumber}
//               type="button"
//               className={isActive ? 'dot_border black' : 'dot_border'}
//               onClick={() => onClickDotEvent(pageNumber)}
//               aria-label={`${pageNumber}번 페이지로 이동`}
//               aria-current={isActive ? 'true' : undefined}
//             >
//               <span
//                 className={isActive ? 'dot_style black' : 'dot_style'}
//                 aria-hidden="true"
//               />
//             </button>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default Dots;